import { Check, ArrowRight, MessageCircle } from "lucide-react";
import { Eyebrow, Reveal } from "./motion";
import { OFFER } from "../config/content";
import { genericWhatsAppLink } from "../lib/api";

export default function Offer({ onBook }) {
  return (
    <section className="py-16 md:py-24" data-testid="offer-section">
      <div className="max-w-[1180px] mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative rounded-3xl bg-[#0F1712] border border-[#22C55E]/40 p-6 sm:p-10 lg:p-14 overflow-hidden shadow-[0_0_90px_-24px_rgba(34,197,94,0.45)]">
            <div className="absolute -top-32 right-0 w-[420px] h-[420px] bg-[#22C55E]/10 blur-[110px] rounded-full pointer-events-none" aria-hidden="true" />
            <div className="relative grid lg:grid-cols-[1.2fr_0.8fr] gap-10">
              <div>
                <Eyebrow>{OFFER.eyebrow}</Eyebrow>
                <h2 className="font-heading uppercase text-white text-4xl sm:text-5xl leading-[0.95] tracking-wide" data-testid="offer-heading">
                  {OFFER.titleA} <span className="text-[#FACC15]">{OFFER.titleHighlight}</span>
                </h2>
                <p className="mt-5 text-base sm:text-lg text-[#A7B3AA] leading-relaxed" data-testid="offer-text">{OFFER.text}</p>
                <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-3" data-testid="offer-checklist">
                  {OFFER.checklist.map((item) => (
                    <li key={item} className="flex items-start gap-2.5">
                      <Check className="w-5 h-5 text-[#22C55E] shrink-0 mt-0.5" strokeWidth={3} />
                      <span className="text-sm sm:text-base text-[#A7B3AA]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex flex-col justify-center">
                <button
                  onClick={onBook}
                  data-testid="offer-book-button"
                  className="btn-primary group relative inline-flex items-center justify-center gap-3 rounded-full bg-[#22C55E] hover:bg-[#16A34A] text-[#04100A] font-extrabold text-base px-8 py-4 transition-colors overflow-hidden w-full"
                >
                  <span className="relative z-10">{OFFER.cta}</span>
                  <ArrowRight className="w-5 h-5 relative z-10 arrow-slide" />
                  <span className="shine" aria-hidden="true" />
                </button>
                <a
                  href={genericWhatsAppLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="offer-whatsapp-link"
                  className="mt-4 inline-flex items-center justify-center gap-2 text-sm text-[#A7B3AA] hover:text-[#22C55E] transition-colors"
                >
                  <MessageCircle className="w-4 h-4" />
                  {OFFER.whatsappLine}
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
